module.exports = __webpack_public_path__ + "img/appAsset-brand--bsale.1cbd5821.svg";